import endpointMeta, { categoryOrder } from './endpointMeta';

function prettyJson(raw) {
  if (!raw || !raw.trim()) return null;
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw.trim();
  }
}

function pathFromUrl(url) {
  if (!url) return '/';
  const parts = Array.isArray(url.path) ? url.path.slice(1) : [];
  return '/' + parts.join('/');
}

// Builds a documentation-ready, credential-free model from a Postman
// collection export. Any "auth" block (Basic Auth username/password) is
// intentionally ignored — credentials are never surfaced in the UI.
export function parseCollection(collectionJson) {
  const items = collectionJson?.item ?? [];
  const endpoints = items.map((item, index) => {
    const meta = endpointMeta[item.name] || {
      slug: `endpoint-${index}`,
      category: 'Other',
      summary: item.name,
      description: '',
    };

    const req = item.request || {};
    const method = (req.method || 'GET').toUpperCase();
    const url = req.url || {};
    const path = pathFromUrl(url);

    const queryParams = (url.query || []).map((q) => ({
      key: q.key,
      example: q.value ?? '',
      required: q.disabled !== true,
    }));

    const requestBody = method !== 'GET' ? prettyJson(req.body?.raw) : null;

    const firstResponse = Array.isArray(item.response) ? item.response[0] : null;
    const responseExample = firstResponse
      ? {
          status: firstResponse.status || 'OK',
          code: firstResponse.code || 200,
          body: prettyJson(firstResponse.body),
        }
      : null;

    return {
      id: meta.slug,
      name: item.name,
      method,
      path,
      category: meta.category,
      summary: meta.summary,
      description: meta.description,
      queryParams,
      requestBody,
      responseExample,
    };
  });

  const byCategory = new Map();
  endpoints.forEach((ep) => {
    if (!byCategory.has(ep.category)) byCategory.set(ep.category, []);
    byCategory.get(ep.category).push(ep);
  });

  const orderedCategories = [
    ...categoryOrder.filter((c) => byCategory.has(c)),
    ...[...byCategory.keys()].filter((c) => !categoryOrder.includes(c)),
  ];

  return orderedCategories.map((category) => ({
    category,
    endpoints: byCategory.get(category),
  }));
}

export default parseCollection;
